import React from "react";
import "./Offer.css";
const Offer = () => {
  return (
    <>
      <section id="special">
        <div class="container">
          <div class="row justify-content-center">
            <div class=" col-md-6">
              <h3>Special Offer for Couples</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt.
              </p>
              <div class="offer">
                <img
                  src="https://html-templates.evonicmedia.com/adventurist/assets/images/index/special-img2.webp"
                  alt="discount"
                />
                <div class="overlaytwo">
                  <div class="overlay_text">
                    <h3>Discount up 50%</h3>
                    <div class="globalBtn mt-lg-5 mt-4">
                      <ul>
                        <li>
                          <a href="https://html-templates.evonicmedia.com/adventurist/contact.html">
                            Book Now
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-md-0 mt-4">
              <div class="offer">
                <img
                  src="https://html-templates.evonicmedia.com/adventurist/assets/images/index/special-img1.webp"
                  alt="discount"
                />
                <div class="overlaytwo">
                  <div class="overlay_text">
                    <h3>Discount up 50%</h3>
                    <div class="globalBtn mt-lg-5 mt-4">
                      <ul>
                        <li>
                          <a href="https://html-templates.evonicmedia.com/adventurist/contact.html">
                            Book Now
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Special Offer on Adventure tours</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Offer;
